import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ChangeDetectorRef } from '@angular/core';
import {
  DropdownControlComponent,
  IDropdownSelect,
} from '../../components/form/dropdown-control/dropdown-control.component';
import { AutocompleteControlComponent } from '../../components/form/autocomplete-control/autocomplete-control.component';
import { InlineInputControlComponent } from '../../components/form/inline-input-control/inline-input-control.component';
import { Platform } from '@angular/cdk/platform';
import {
  BootstrapGridBreakpoints,
  BreakpointsService,
} from '../../services/breakpoints.service';
import {
  combineLatest,
  filter,
  map,
  Observable,
  startWith,
  Subject,
  Subscription,
  switchMap,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TabViewChangeEvent, TabViewModule } from 'primeng/tabview';
import { StateService } from '../../../core/state/old/state.service';
import {
  MutationAddVehicleArgs,
  MutationRemoveVehicleArgs,
  MutationSelectVehicleArgs,
  Query,
  QueryVehicleManufacturersArgs,
  QueryVehicleModelsArgs,
  QueryVehicleModificationByIdArgs,
  QueryVehicleModificationByLicensePlateArgs,
  QueryVehicleModificationsArgs,
  SavedVehicle,
  VehicleModification,
  VehicleSearchItem,
} from '../../../graphql/generated/generated-types';
import { GET_VEHICLE_YEARS } from './vehicle-years.graphql';
import { DataService } from '../../../core/providers/data/data.service';
import { SelectButtonControlComponent } from '../../components/form/select-button-control/select-button-control.component';
import { GET_VEHICLE_MANUFACTURERS } from './vehicle-manufacturers.graphql';
import { GET_VEHICLE_MODELS } from './vehicle-models.graphql';
import { GET_VEHICLE_MODIFICATIONS } from './vehicle-modifications.graphql';
import { GET_VEHICLE_MODIFICATION_BY_ID } from './vehicle-modification-by-id.graphql';
import { HttpErrorResponse } from '@angular/common/http';
import { GET_SAVED_VEHICLES } from './saved-vehicles.graphql';
import { ADD_VEHICLE } from './add-vehicle.graphql';
import { REMOVE_VEHICLE } from './remove-vehicle.graphql';
import { ToastSeverity } from '../../notification/notification.component';
import { MessageService } from 'primeng/api';
import { SELECT_VEHICLE } from './select-vehicle.graphql';
import { ActiveService } from '../../../core/providers/active/active.service';
import { GET_VEHICLE_MODIFICATIONS_BY_LICENSE_PLATE } from './vehicle-modifications-by-license-plate.graphql';
import { VehicleTypeService } from '../../services/vehicle-type.service';
import { SelectedModificationService } from '../../services/selected-modification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AddVehicleFields, VehicleType } from './vehcle-type.interfaces';





@Component({
  selector: 'app-add-vehicle-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    DropdownControlComponent,
    AutocompleteControlComponent,
    InlineInputControlComponent,
    TabViewModule,
    SelectButtonControlComponent,
  ],
  templateUrl: './add-vehicle-form.component.html',
  styleUrl: './add-vehicle-form.component.scss',
})
export class AddVehicleFormComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  public licensePlateControl: FormControl = new FormControl('');
  public years: IDropdownSelect[] = [];
  private vehicleYearsQuery$: Observable<VehicleSearchItem[]>;
  public brands: IDropdownSelect[] = [];
  private vehicleManufacturersQuery$: Observable<VehicleSearchItem[]>;

  public filteredBrands: IDropdownSelect[] = [];

  public models: IDropdownSelect[] = [];
  private vehicleModelsQuery$: Observable<VehicleSearchItem[]>;
  public filteredModels: IDropdownSelect[] = [];

  public engines: IDropdownSelect[] = [];
  private vehicleEnginesQuery$: Observable<VehicleSearchItem[]>;
  public filteredEngines: IDropdownSelect[] = [];

  public vehicleTabActiveIndex: number = 0;
  public vehicleTypes: IDropdownSelect[] = [
    { label: 'Passenger', value: VehicleType.Passenger },
    { label: 'Truck', value: VehicleType.Truck },
    { label: 'Commercial', value: VehicleType.Commercial },
    { label: 'Moto', value: VehicleType.Moto },
    { label: 'ATV', value: VehicleType.ATV },
    { label: 'Agro', value: VehicleType.Agro },
    // {label: 'Other', value: VehicleType.Others},
  ];
  public VehicleType = VehicleType;

  public AddVehicleFields = AddVehicleFields;
  public addVehicleFormGroup: FormGroup = new FormGroup({
    [AddVehicleFields.Type]: new FormControl(VehicleType.Passenger),
    [AddVehicleFields.Year]: new FormControl(undefined),
    [AddVehicleFields.Brand]: new FormControl(undefined),
    [AddVehicleFields.Model]: new FormControl(undefined),
    [AddVehicleFields.Engine]: new FormControl(undefined),
  });

  @Input() showManualForm: boolean = true;
  @Input() notFoundByLicensePlate: boolean = false;
  public selectVehiclesFromLicensePlateSearch: boolean = false;

  public smLayout: boolean = true;
  private mdSubscription: Subscription = new Subscription();

  public selectedVehicle: SavedVehicle | null;
  public savedVehicles: SavedVehicle[];
  activeVehicle$: Observable<SavedVehicle | null>;

  public loading: boolean = true;

  public vehicleModificationsByLicensePlate: VehicleModification[] = [];
  public mdActiveIndex: number = 0;
  constructor(
    private ref: ChangeDetectorRef,
    private platform: Platform,
    private breakpointsService: BreakpointsService,
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private stateService: StateService,
    private dataService: DataService,
    private messageService: MessageService,
    private activeService: ActiveService,
    private selectedModificationService: SelectedModificationService,
    private vehicleTypeService: VehicleTypeService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (this.platform.isBrowser) {
      this.mdSubscription = this.breakpointsService
        .isBreakpointOrLower(BootstrapGridBreakpoints.SMlabel)
        .subscribe({
          next: (matches: boolean) => {
            this.smLayout = matches;
          },
        });
    }
  }

  ngOnInit(): void {
    this.ref.detectChanges();
    this.setActiveVehicleTypeTab();
    
    this.onVehicleTypeControlChange();
    this.createVehicleYearsObservable();
    this.createVehicleManufacturersObservable();
    this.createVehicleModelsObservable();
    this.createVehicleEnginesObservable();

    this.subscribeToVehicleYearControl();
    this.subscribeToVehicleBrandControl();
    this.subscribeToVehicleModelControl();
    this.subscribeToVehicleEngineControl();

    this.getActiveVehicle();
    this.getMySavedVehicles();
  
  }

  ngOnDestroy(): void {
    if (this.mdSubscription) {
      this.mdSubscription.unsubscribe();
    }

    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private setActiveVehicleTypeTab() {
    const vehicleType = this.vehicleTypeService.getCurrentVehicleType();
    if (vehicleType) {
      const index = this.vehicleTypes.findIndex(
        (item) => item.value === vehicleType
      );
      if (index !== -1) {
        this.vehicleTabActiveIndex = index;
      }
    }
  }

  private getActiveVehicle() {
    this.activeVehicle$ = this.activeService.activeVehicle$?.pipe(take(1));

    this.activeVehicle$.subscribe({
      next: (response: SavedVehicle | null) => {
        if (response) {
          this.selectedVehicle = response;
          this.stateService.setState('activeVehicleId', response.id);
        } else {
          this.selectedVehicle = null;
          this.stateService.setState('activeVehicleId', null);
        }
      },
      error: () => { },
      complete: () => { },
    });
  }

  public onYearCleared() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Brand)
      ?.setValue(undefined, { emitEvent: false });
    this.addVehicleFormGroup
      .get(AddVehicleFields.Model)
      ?.setValue(undefined, { emitEvent: false });
    this.addVehicleFormGroup
      .get(AddVehicleFields.Engine)
      ?.setValue(undefined, { emitEvent: false });
  }

  public onBrandCleared() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Model)
      ?.setValue(undefined, { emitEvent: false });
    this.addVehicleFormGroup
      .get(AddVehicleFields.Engine)
      ?.setValue(undefined, { emitEvent: false });
  }

  public onModelCleared() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Engine)
      ?.setValue(undefined, { emitEvent: false });
  }

  public onEngineCleared() { }

  private subscribeToVehicleYearControl() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Year)
      ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: number) => {
        if (value) {
          this.onYearCleared();
        }
      });
  }

  private subscribeToVehicleBrandControl() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Brand)
      ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: number) => {
        if (value) {
          this.onBrandCleared();
        }
      });
  }

  private subscribeToVehicleModelControl() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Model)
      ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: number) => {
        if (value) {
          this.onModelCleared();
        }
      });
  }

  private subscribeToVehicleEngineControl() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Engine)
      ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: number) => {
        if (value) {
          this.addVehicleToMySavedList(null);
        }
      });
  }

  public getVehicleModificationsByLicensePlate() {
    this.loading = true;
    const licensePlateString = Object.values(
      this.licensePlateControl.getRawValue()
    ).join('');
    this.dataService
      .mutate<Query, QueryVehicleModificationByLicensePlateArgs>(
        GET_VEHICLE_MODIFICATIONS_BY_LICENSE_PLATE,
        {
          input: {
            licensePlate: licensePlateString,
          },
        }
      )
      .pipe(
        take(1),
        map(
          (data) =>
            data.vehicleModificationsByLicensePlate as VehicleModification[]
        )
      )
      .subscribe({
        next: (response: VehicleModification[]) => {
          if (response?.length > 0) {
            this.vehicleModificationsByLicensePlate = response;
            this.selectVehiclesFromLicensePlateSearch = true;
          } else {
            this.selectVehiclesFromLicensePlateSearch = false;
            this.notFoundByLicensePlate = true;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.selectVehiclesFromLicensePlateSearch = false;
          this.notFoundByLicensePlate = true;
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  private getVehicleModificationById(
    modificationId: number,
    resetSavedList?: boolean
  ) {
    this.dataService
      .mutate<Query, QueryVehicleModificationByIdArgs>(
        GET_VEHICLE_MODIFICATION_BY_ID,
        {
          input: {
            modificationId: modificationId,
            vehicleType: this.addVehicleFormGroup.get(AddVehicleFields.Type)
              ?.value,
          },
        }
      )
      .pipe(
        take(1),
        map((data) => data.vehicleModificationById as VehicleModification)
      )
      .subscribe({
        next: (response: VehicleModification) => { },
        error: (error: HttpErrorResponse) => { },
        complete: () => {
          if (resetSavedList) {
            this.getMySavedVehicles();
          }
        },
      });
  }

  public addVehicleToMySavedList(
    vehicleFromLicensePlate?: VehicleModification | null
  ) {
    this.loading = true;
    const licensePlateString = Object.values(
      this.licensePlateControl.getRawValue()
    ).join('');

    this.dataService
      .mutate<any, MutationAddVehicleArgs>(ADD_VEHICLE, {
        input: {
          licensePlate: vehicleFromLicensePlate
            ? licensePlateString
            : undefined,
          modificationId: vehicleFromLicensePlate
            ? vehicleFromLicensePlate.id
            : this.addVehicleFormGroup.get(AddVehicleFields.Engine)?.value ||
            null,
          vehicleType: vehicleFromLicensePlate
            ? vehicleFromLicensePlate.vehicleType
            : this.addVehicleFormGroup.get(AddVehicleFields.Type)?.value,
          year: vehicleFromLicensePlate
            ? null
            : this.addVehicleFormGroup.get(AddVehicleFields.Year)?.value,
        },
      })
      .pipe(
        take(1),
        map((data) => data.addVehicle as SavedVehicle)
      )
      .subscribe({
        next: (response: SavedVehicle) => {
          if (response) {
            this.selectedModificationService.setModificationId(response.modificationId)
            this.afterVehicleSelected(response);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.selectVehiclesFromLicensePlateSearch = false;
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
          this.getMySavedVehicles();
        },
      });
  }

  public getMySavedVehicles() {
    this.loading = true;
    this.dataService
      .query<Query>(GET_SAVED_VEHICLES)
      .pipe(
        map((data: Query) => data.savedVehicles as SavedVehicle[]),
        take(1)
      )
      .subscribe({
        next: (response: SavedVehicle[]) => {
          this.savedVehicles = response;
          if (this.smLayout && (!response || response?.length == 0)) {
            this.mdActiveIndex = 1;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  public onVehicleTabChange(event: TabViewChangeEvent) {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Type)
      ?.setValue(this.vehicleTypes[event.index].value);
    this.vehicleTypeService.setVehicleType(
      this.vehicleTypes[event.index].value
    );
    this.getActiveVehicle();
    this.getMySavedVehicles();
  }

  public onVehicleTypeControlChange() {
    this.addVehicleFormGroup
      .get(AddVehicleFields.Type)
      ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: string) => {
        this.addVehicleFormGroup
          .get(AddVehicleFields.Brand)
          ?.setValue(undefined, { emitEvent: false });
        this.addVehicleFormGroup
          .get(AddVehicleFields.Model)
          ?.setValue(undefined, { emitEvent: false });
        this.addVehicleFormGroup
          .get(AddVehicleFields.Engine)
          ?.setValue(undefined, { emitEvent: false });
        this.addVehicleFormGroup
          .get(AddVehicleFields.Year)
          ?.setValue(undefined, { emitEvent: true });
      });
  }

  public createVehicleYearsObservable() {
    const typeControl = this.addVehicleFormGroup.get(AddVehicleFields.Type)!;
    this.vehicleYearsQuery$ = combineLatest([
      typeControl.valueChanges.pipe(startWith(typeControl.value)),
    ]).pipe(
      tap(() => (this.loading = true)),
      switchMap(([vehicleType]) =>
        this.dataService.query<Query>(
          GET_VEHICLE_YEARS,
          {},
          'cache-and-network'
        )
      ),
      map((data) => data.vehicleYears.all as VehicleSearchItem[])
    );

    this.vehicleYearsQuery$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (response: VehicleSearchItem[]) => {
        this.years = response.map((item) => {
          return { label: item.name, value: item.id };
        });
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  private createVehicleManufacturersObservable() {
    const yearControl = this.addVehicleFormGroup.get(AddVehicleFields.Year)!;
    const typeControl = this.addVehicleFormGroup.get(AddVehicleFields.Type)!;

    this.vehicleManufacturersQuery$ = combineLatest([
      yearControl.valueChanges.pipe(startWith(yearControl.value)),
      typeControl.valueChanges.pipe(startWith(typeControl.value)),
    ]).pipe(
      filter(([vehicleYear, vehicleType]) => !!vehicleYear && !!vehicleType), // Ensure both values are present
      tap(() => (this.loading = true)),
      switchMap(([vehicleYear, vehicleType]) =>
        this.dataService.query<Query, QueryVehicleManufacturersArgs>(
          GET_VEHICLE_MANUFACTURERS,
          { input: { year: vehicleYear, vehicleType: vehicleType } },
          'cache-and-network'
        )
      ),
      map((data) => data.vehicleManufacturers.all as VehicleSearchItem[])
    );

    this.vehicleManufacturersQuery$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response: VehicleSearchItem[]) => {
          this.brands = response.map((item) => {
            return { label: item.name, value: item.id };
          });
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  private createVehicleModelsObservable() {
    const manufacturerControl = this.addVehicleFormGroup.get(
      AddVehicleFields.Brand
    )!;
    const yearControl = this.addVehicleFormGroup.get(AddVehicleFields.Year)!;
    const typeControl = this.addVehicleFormGroup.get(AddVehicleFields.Type)!;

    this.vehicleModelsQuery$ = combineLatest([
      manufacturerControl.valueChanges.pipe(
        startWith(manufacturerControl.value)
      ),
      yearControl.valueChanges.pipe(startWith(yearControl.value)),
      typeControl.valueChanges.pipe(startWith(typeControl.value)),
    ]).pipe(
      filter(
        ([manufacturerId, vehicleYear, vehicleType]) =>
          !!manufacturerId && !!vehicleYear && !!vehicleType
      ),
      tap(() => (this.loading = true)),
      switchMap(([manufacturerId, vehicleYear, vehicleType]) =>
        this.dataService.query<Query, QueryVehicleModelsArgs>(
          GET_VEHICLE_MODELS,
          {
            input: {
              manufacturerId: manufacturerId,
              year: vehicleYear,
              vehicleType: vehicleType,
            },
          },
          'cache-and-network'
        )
      ),
      map((data) => data.vehicleModels.all as VehicleSearchItem[])
    );

    this.vehicleModelsQuery$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (response: VehicleSearchItem[]) => {
        this.models = response.map((item) => {
          return { label: item.name, value: item.id };
        });
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  private createVehicleEnginesObservable() {
    const modelControl = this.addVehicleFormGroup.get(AddVehicleFields.Model)!;
    const manufacturerControl = this.addVehicleFormGroup.get(
      AddVehicleFields.Brand
    )!;
    const yearControl = this.addVehicleFormGroup.get(AddVehicleFields.Year)!;
    const typeControl = this.addVehicleFormGroup.get(AddVehicleFields.Type)!;

    this.vehicleEnginesQuery$ = combineLatest([
      modelControl.valueChanges.pipe(startWith(modelControl.value)),
      manufacturerControl.valueChanges.pipe(
        startWith(manufacturerControl.value)
      ),
      yearControl.valueChanges.pipe(startWith(yearControl.value)),
      typeControl.valueChanges.pipe(startWith(typeControl.value)),
    ]).pipe(
      filter(
        ([modelId, manufacturerId, vehicleYear, vehicleType]) =>
          !!modelId && !!manufacturerId && !!vehicleYear && !!vehicleType
      ),
      tap(() => (this.loading = true)),
      switchMap(([modelId, manufacturerId, vehicleYear, vehicleType]) =>
        this.dataService.query<Query, QueryVehicleModificationsArgs>(
          GET_VEHICLE_MODIFICATIONS,
          {
            input: {
              modelId: modelId,
              manufacturerId: manufacturerId,
              year: vehicleYear,
              vehicleType: vehicleType,
            },
          },
          'cache-and-network'
        )
      ),
      map((data) => data.vehicleModifications.all as VehicleSearchItem[])
    );

    this.vehicleEnginesQuery$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (response: VehicleSearchItem[]) => {
        this.engines = response.map((item) => {
          return { label: item.name, value: item.id };
        });
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  public filterBrands(event: AutoCompleteCompleteEvent) {
    const filtered: any[] = [];
    const query = event.query;

    for (let i = 0; i < (this.brands as any[]).length; i++) {
      const brand = (this.brands as any[])[i];
      if (brand.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(brand);
      }
    }
    this.filteredBrands = filtered;
  }

  public filterModels(event: AutoCompleteCompleteEvent) {
    const filtered: any[] = [];
    const query = event.query;

    for (let i = 0; i < (this.models as any[]).length; i++) {
      const model = (this.models as any[])[i];
      if (model.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(model);
      }
    }
    this.filteredModels = filtered;
  }

  public filterEngines(event: AutoCompleteCompleteEvent) {
    const filtered: any[] = [];
    const query = event.query;

    for (let i = 0; i < (this.engines as any[]).length; i++) {
      const engine = (this.engines as any[])[i];
      if (engine.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(engine);
      }
    }
    this.filteredEngines = filtered;
  }

  public clearNotFound() {
    this.showManualForm = true;
    this.notFoundByLicensePlate = false;
    this.licensePlateControl.setValue('');
    this.getActiveVehicle();
    this.getMySavedVehicles();
  }

  public removeVehicleFromSaved(vehicleId: any) {
    this.loading = true;
    this.dataService
      .mutate<Query, MutationRemoveVehicleArgs>(REMOVE_VEHICLE, {
        id: vehicleId,
      })
      .pipe(take(1))
      .subscribe({
        error : () => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
          this.messageService.add({
            severity: ToastSeverity.Success,
            key: 'notifications',
            summary: 'Success',
            detail: `Vehicle removed successfully.`,
          });
          this.getActiveVehicle();
          this.getMySavedVehicles();
        },
      });
  }

  public setActiveVehicle(vehicleId?: any) {
    this.loading = true;
    this.dataService
      .mutate<any, MutationSelectVehicleArgs>(SELECT_VEHICLE, {
        id: vehicleId,
      })
      .pipe(
        take(1),
        map((data) => data.selectVehicle as SavedVehicle)
      )
      .subscribe({
        next: (response: SavedVehicle) => {
          if (response) {
            this.selectedModificationService.setModificationId(response.modificationId)
            this.afterVehicleSelected(response);
          } else if (!vehicleId && !response) {
            // UNSELECTING ACTIVE VEHICLE
            this.selectedVehicle = null;
            this.stateService.setState('activeVehicleId', null);
            this.selectedModificationService.deleteModificationId();

          }
        },
        error : (error) => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  private afterVehicleSelected(vehicle: SavedVehicle) {
    this.notFoundByLicensePlate = false;
    this.showManualForm = true;
    this.selectVehiclesFromLicensePlateSearch = false;

    this.licensePlateControl.setValue('');
    this.activeService.suggestedVehicleDialogIsOpened = true; // Make it wont open on because it will reload
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { modificationId: vehicle.modificationId },
      queryParamsHandling: 'merge', // keeps existing params
      replaceUrl: true,
    })

    
    this.messageService.add({
      severity: ToastSeverity.Success,
      key: 'notifications',
      detail: `New vehicle selected.`,
    });
    if (this.smLayout) {
      this.stateService.setState('addVehicleBottomSheetOpened', false);
    } else {
      this.dialogRef.close(true);
    }
  }


  

  public enableAddVehicleFormInMd() {
    this.showManualForm = true;
    this.selectVehiclesFromLicensePlateSearch = false;
    this.notFoundByLicensePlate = false;
  }

  public disableAddVehicleFormInMd() {
    this.selectVehiclesFromLicensePlateSearch = false;
    this.notFoundByLicensePlate = false;
  }

  public removeVehicleFromActive() {
    this.setActiveVehicle(); // select vehicle without id so it will unselect active vehicle
  }
}
